/**
 * @generated SignedSource<<caed1cc1b92f58d64a22809a9ebbf891>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type parentIssueField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly parentIssue: {
    readonly issueId: string;
    readonly key: string;
    readonly summary: string | null;
  } | null;
  readonly " $fragmentType": "parentIssueField_updateWorkItemFieldsActionRenderer";
};
export type parentIssueField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: parentIssueField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"parentIssueField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "parentIssueField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "issueId"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "summary"
        }
      ]
    }
  ],
  "type": "JiraParentIssueField"
};

(node as any).hash = "a4a14dae923ead052fad903fcbfd9e9a";

export default node;
